module.exports = __webpack_public_path__ + "static/media/burger.19913658.svg";